module.exports = __webpack_public_path__ + "img/09.6eec2c36.png";